<template>
  <sui-modal class="wrapper" :size="size" v-model="visible" :closable="false" :style="{zIndex}">
    <sui-modal-header class="header">
      Add provider
    </sui-modal-header>
    <sui-modal-content>
      <sui-form v-show="!entity" @submit.prevent="submit()">
        <sui-form-fields>
          <sui-form-field class="roles">
            <h4 class="ui header">Hosting providers</h4>
            <sui-card-group class="types" :itemsPerRow="typesByGroup.Hosting.length">
              <sui-card class="link type" v-for="type in typesByGroup.Hosting" :key="type.providerType" @click="selectType(type)">
                <div class="type-logo">
                  <Logo class="logo" :providerType="type.providerType" />
                </div>
              </sui-card>
            </sui-card-group>
          </sui-form-field>
          <sui-form-field :width="1">
          </sui-form-field>
          <sui-form-field class="roles">
            <h4 class="ui header">Log providers</h4>
            <sui-card-group class="types" :itemsPerRow="1">
              <sui-card class="link type" v-for="type in typesByGroup.Logs" :key="type.providerType" @click="selectType(type)">
                <div class="type-logo">
                  <Logo class="logo" :providerType="type.providerType" />
                </div>
              </sui-card>
            </sui-card-group>
          </sui-form-field>
        </sui-form-fields>
        <sui-form-field class="roles">
          <h4 class="ui header">Storage providers</h4>
          <sui-card-group class="doubling types" :itemsPerRow="typesByGroup.Storage.length">
            <sui-card class="link type" v-for="type in typesByGroup.Storage" :key="type.providerType" @click="selectType(type)">
              <div class="type-logo">
                <Logo class="logo" :providerType="type.providerType" />
              </div>
            </sui-card>
          </sui-card-group>
        </sui-form-field>
      </sui-form>
      <sui-form :error="hasApiErrors" :loading="loading" @submit="submit()" v-if="entity">
        <FormProvider v-model="entity" mode="creating" />
        <sui-message error>
          {{apiErrors}}
        </sui-message>
        <div class="help" v-if="entity.constructor.helpLink || entity.constructor.referal">
          <div v-if="entity.constructor.helpLink">If you need help, check our <a :href="entity.constructor.helpLink" target="_blank">docs</a>.</div>
          <div v-if="entity.constructor.referal" v-html="entity.constructor.referal" />
        </div>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button class="back" icon="arrow circle left" label-position="left" v-if="entity" @click="reset()">
        Back
      </sui-button>
      <div class="ui buttons">
        <sui-button icon="check" label-position="left" color="green" :disabled="loading || hasEntityErrors" @click="submit()" data-goal="CREATE_PROVIDER_TRY">Confirm</sui-button>
        <sui-button icon="ban" label-position="right" color="red" @click="cancel()">Cancel</sui-button>
      </div>
    </sui-modal-actions>
    <sui-dimmer class="dimmer" :active="success" inverted>
      <h2 class="ui icon header">
        <i class="green check circle icon" />
        Success
      </h2>
    </sui-dimmer>
  </sui-modal>
</template>

<script>
  import groupBy from 'lodash/groupBy'
  import FormProvider from '@/components/forms/Provider'
  import ModalForm from '@/mixins/ModalForm'
  import objects from '@/objects'
  import utils from '@/utils'

  export default {
    name: 'ModalCreateProvider',
    mixins: [
      ModalForm,
    ],
    components: {
      FormProvider,
    },
    computed: {
      size() {
        return this.entity ? 'small' : 'standard'
      },
      typesByGroup() {
        const activeProviders = objects._providers.filter(object => object.active).sort((object1, object2) => object1.order - object2.order)
        return groupBy(activeProviders, 'purposeTitle')
      },
    },
    methods: {
      open(entity = null, callback) {
        this.visible = true
        this.$options.callback = callback
        if (entity) {
          this.entity = {...entity}
        }
      },
      selectType(type) {
        utils.reachGoal(`CREATE_PROVIDER_SELECT_${type.providerType.toUpperCase()}`)
        if (type && !type.soon) {
          this.entity = {type: type.providerType}
        }
      },
      onSuccess(result) {
        this.close()
        utils.reachGoal('CREATE_PROVIDER_SUCCESS')
        if (this.$options.callback) {
          this.$options.callback(result)
        }
      },
      onFail() {
        utils.reachGoal('CREATE_PROVIDER_FAIL')
      },
    },
    created() {
      this.$modals.createProvider = this
    },
  }
</script>

<style scoped>
  .types { align-items: stretch; }
  .type { text-align: center; }
  .type-logo { display: flex; justify-content: center; background-color: #eee; }
  .type-title { padding: .3em; font-weight: bold; }
  .logo { margin: .5em; height: 5em; }
  .help { margin: 1em 0 0!important; color: #999; font-size: .9em; }
  .back { float: left; text-align: left; }
  .one.cards { margin-right: -1em!important; }
  .one.cards .card { width: calc(100% - 1.5em)!important; }
</style>
